import React from 'react';

export default function RiskIndicator({ level }) {
  const config =
    {
      low: { label: 'Low', className: 'sp-risk--low' },
      medium: { label: 'Medium', className: 'sp-risk--medium' },
      high: { label: 'High', className: 'sp-risk--high' },
      critical: { label: 'Critical', className: 'sp-risk--critical' }
    }[level] || { label: 'Unknown', className: '' };

  return (
    <div className={`sp-risk ${config.className}`}>
      <span className="sp-risk-dot" />
      <span>{config.label}</span>
    </div>
  );
}
